document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('[data-vcl-block]');
  const storageKey = 'vcl-expanded';

  blocks.forEach(function (block) {
    const button = block.querySelector('[data-vcl-toggle]');
    const hiddenItems = block.querySelectorAll('[data-vcl-hidden-item]');
    const isExpanded = window.sessionStorage.getItem(storageKey) === 'true';

    if (isExpanded) {
      block.classList.add('is-expanded');

      hiddenItems.forEach(function (item) {
        item.hidden = false;
      });

      if (button) {
        button.style.display = 'none';
        button.setAttribute('aria-expanded', 'true');
      }
    }

    if (!button) return;

    button.addEventListener('click', function () {
      block.classList.add('is-expanded');

      hiddenItems.forEach(function (item) {
        item.hidden = false;
      });

      button.style.display = 'none';
      button.setAttribute('aria-expanded', 'true');
      window.sessionStorage.setItem(storageKey, 'true');
    });
  });
});